<template>
  <div v-if="factureVenteInterne && detailFactureVenteInterne"
         class="is-marginless is-paddingless section section-details">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t(getTitle, { code: factureVenteInterne.code }) }}
                <b-tag type="has-background-subMenu"
                       class="has-text-white mgl-5px">
                  {{ $t(getEtatFacture) }}
                </b-tag>
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right" v-if="canSeeFacture">
          <button class="button" v-if="activeButtonEtLien
          && detailFactureVenteInterne.etat !== constantes.ETAT_BROUILLON
          && detailFactureVenteInterne.montantTtc !== 0">
            <b-dropdown position="is-bottom-left" aria-role="list" class="has-text-left">
              <a slot="trigger">
                <b-icon class="is-flex"
                        custom-class="has-text-icon-more"
                        icon="dots-vertical">
                </b-icon>
              </a>
              <b-dropdown-item
                @click="checkPermissions(constantes.FACTURES.maj) ?
                    generateEcritureComptable() : showPopUp()">
                {{ $t('detail.buttons.generateEcriture') }}
              </b-dropdown-item>
            </b-dropdown>
          </button>
          <mail-button
            class="mgl-2"
            :perm="constantes.FACTURES.lecture"
            :titlePopUp="'detailFacture.popUpMail.title'"
            :dcfDetail="detailFactureVenteInterne"
            :editionsAInclure="editionsAInclure"
            :mailSetUp="mailSetUp">
          </mail-button>
          <button class="button mgl-10px"
                  @click="$refs.dropdownEdition.toggle()">
            <div>
              <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
              <b-dropdown ref="dropdownEdition" class="has-text-left">
                <div slot="trigger">
                  <b-icon icon="chevron-down"
                          class="has-text-secondary-icon">
                  </b-icon>
                </div>
                <b-dropdown-item
                  @click="checkPermissions(constantes.FACTURES.editer) ?
                edition(constantes.TYPE_PDF) : showPopUp()">
                  {{ $t('general.popUpEdition.type.pdf') }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="checkPermissions(constantes.FACTURES.editer) ?
                edition(constantes.TYPE_DOCX) : showPopUp()">
                  {{ $t('general.popUpEdition.type.docx') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </button>
          <button class="button mgl-10px" v-if="activeButtonEtLien"
                  @click="checkPermissions(constantes.FACTURES.maj) ?
                      showAddAttachmentModal() : showPopUp()">
            <b-icon icon="paperclip" type="is-default"></b-icon>
          </button>
        </div>
      </div>
      <div v-if="canSeeFacture && !activeButtonEtLien">
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('detail.infos.facture') }]"
                                       :canClose="false">
        </app-information-msg-component>
      </div>
      <div class="tab" v-if="canSeeFacture">
        <ul>
          <li @click="activeTab = 'AppDetailFacture'"
              :class="{'is-active': activeTab === 'AppDetailFacture'}">
            {{ $t('detailFacture.achatVenteInterne.vente.tab.detail')}}
          </li>
          <li @click="activeTab = 'EcrituresComptaDetail'"
              v-if="detailFactureVenteInterne.id && detailFactureVenteInterne.montantTtc !== 0"
              :class="{'is-active': activeTab === 'EcrituresComptaDetail'}">
            {{ $t('detailFacture.achatVenteInterne.vente.tab.ecritureCompta')}}
          </li>
        </ul>
      </div>
    </div>
    <component  v-if="canSeeFacture"
                ref="componentChild"
                :id="factureVenteInterne.id"
                :devisCommande="factureVenteInterne"
                :factureVenteInterne="factureVenteInterne"
                :detailFactureVenteInterne="detailFactureVenteInterne"
                :is="activeTab"
                :ecritures="ecritures">
    </component>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import {
  FACTURE_ETAT,
  TYPE_EDITION_FACTURE,
  TYPE_EDITION_FACTURE_MAIL,
  SOUS_TYPE_AVOIR,
  SOUS_TYPE_AVOIR_SUR_ACOMPTE,
} from '@/configuration/facture/factureConf';
import AppBreadcrumb from '@/components/general/breadcrumb';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/facture';
import getInfoEcheancierPaiement
  from '@/services/echeancePaiement/getInformationEcheancierPaiement';
import { get as getTiers } from '@/api/tiers';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import edition from '@/api/edition/index';
import { TYPE_FACTURE, ETAT_BROUILLON } from '@/configuration/devisConf';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import getInfoContacts from '@/services/general/mail/getInfoContactsMail';
import popUpMail from '@/components/general/p_mail';
import messageSucces from '@/services/general/messageSucces';
import AppDetailFacture from '@/components/bodac/factureVenteInterne/detail';
import { generateByFacture, getByFacture } from '@/api/compta/ifEcriture';
import { TYPE_VENTE } from '@/configuration/compta/ecritureConf';
import EcrituresComptaDetail from '@/components/commun/ecritureComptable/ecrituresComptaDetail';
import mailButton from '@/components/general/button/mailButton';

const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      activeTab: 'AppDetailFacture',
      factureVenteInterne: null,
      detailFactureVenteInterne: null,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      contacts: [],
      mail: null,
      popUpMail: false,
      errorEmail: {
        haveError: false,
        messages: [],
      },
      constantes: {
        TYPE_DOCX,
        TYPE_PDF,
        FACTURES,
        ETAT_BROUILLON,
      },
      ecritures: [],
      editionsAInclure: [{
        libelle: 'detailFacture.popUpMail.inclureFacture', key: 'mettreEdition', value: true, type: TYPE_EDITION_FACTURE_MAIL,
      }],
    };
  },
  components: {
    AppBreadcrumb,
    AppInformationMsgComponent,
    popUpMail,
    AppDetailFacture,
    EcrituresComptaDetail,
    mailButton,
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    isAvoir() {
      return [SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE]
        .includes(this.factureVenteInterne.sousType);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailFacture.achatVenteInterne.vente.breadcrumb.liste'), route: { name: 'l.bodac.factures' }, isActive: false },
        { title: this.$i18n.t('detailFacture.achatVenteInterne.vente.breadcrumb.' + (this.isAvoir ? 'titleAvoir' : 'title')), route: '', isActive: true },
      ];
    },
    mailSetUp() {
      return {
        parametreAgenceCorpMail: 'emailFacturation',
        objet: this.$i18n.t('detailFacture.popUpMail.factureObject', {
          code: this.detailFactureVenteInterne.code,
          date: this.detailFactureVenteInterne.generalInfos.dateDevisCommande,
        }),
        contactDCFTitle: this.$t('detailFacture.popUpMail.contactTitle'),
      };
    },
    getTitle() {
      return this.isAvoir ? 'detailFacture.achatVenteInterne.vente.titleAvoir' : 'detailFacture.achatVenteInterne.vente.title';
    },
    getEtatFacture() {
      return FACTURE_ETAT.find((etatInList) => {
        return etatInList.code === this.factureVenteInterne.etat;
      }).libelle;
    },
    canSeeFacture() {
      return ((this.user.profil === COMMERCIAL
          && this.factureVenteInterne.commercialId === this.user.id)
        || this.user.profil !== COMMERCIAL);
    },
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.factureVenteInterne.societeId);
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async generateEcritureComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generateByFacture(this.detailFactureVenteInterne.id, TYPE_VENTE);
        this.ecritures = (await getByFacture(
          this.factureVenteInterne.id,
          this.factureVenteInterne.sens,
        )).data.result;
        messageSucces(this.$t('detailFacture.messages.success.generateEcriture'));
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    async edition(format) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const response = await edition({
          ids: [this.factureVenteInterne.id],
          extension: format,
          typeDonnee: TYPE_EDITION_FACTURE,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationDevisCommande({ data: response },
            this.errorEdition.messages,
            null,
            TYPE_FACTURE);
          validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
            this.errorEdition.messages, this.errorEdition.messagesChampsVide, translate);
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.factureVenteInterne = (await get(this.$route.params.id)).data.result;
      await this.loadParametres([PARAMETRES_KEYS.categorieGroupeProduitDeductible]);
      await this.setAttachmentContext({ module: 'Facture' });
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.factureVenteInterne.echeancierPaiement = await getInfoEcheancierPaiement(
        this.factureVenteInterne.echeancierPaiement,
      );
      this.contacts = await getInfoContacts(this.factureVenteInterne.intervenants);
      const facture = detailDevisCommande(this.factureVenteInterne, true);
      this.ecritures = (await getByFacture(
        this.factureVenteInterne.id,
        this.factureVenteInterne.sens,
      )).data.result;
      facture.destinataireComptable.compteComptable = (
        await getTiers(facture.destinataireComptable.tiersId)
      ).data.result.compteComptable;
      this.detailFactureVenteInterne = facture;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.detailFactureVenteInterne.code }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
